import { render, staticRenderFns } from "./taskSummaryDetail.vue?vue&type=template&id=03daa2f0&scoped=true"
import script from "./taskSummaryDetail.vue?vue&type=script&lang=js"
export * from "./taskSummaryDetail.vue?vue&type=script&lang=js"
import style0 from "./taskSummaryDetail.vue?vue&type=style&index=0&id=03daa2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03daa2f0",
  null
  
)

export default component.exports